import { Component, OnInit } from '@angular/core';
import { CmsService } from '../cms.service';
import { ConnectService } from '../connect.service';
import * as PrismicDOM from 'prismic-dom';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  public content;
  public generateMarkup(data){
    return PrismicDOM.RichText.asHtml(data);
  }
  constructor(private cms: CmsService, public connectService: ConnectService, private titleService:Title) { }

  ngOnInit() {
    this.titleService.setTitle(`About ThinSlabz® -- ThinSlabz® by Rosetta Stone Group`);

    this.cms.getAbout().subscribe((response) => {
      this.content = response;
      console.log("About: ", response);

    });
  }


}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/about/about.component.ts